import { render, staticRenderFns } from "./DialogManage.vue?vue&type=template&id=9de9e12c&scoped=true"
import script from "./DialogManage.vue?vue&type=script&lang=js"
export * from "./DialogManage.vue?vue&type=script&lang=js"
import style0 from "./DialogManage.vue?vue&type=style&index=0&id=9de9e12c&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9de9e12c",
  null
  
)

export default component.exports